/* eslint-disable no-underscore-dangle */
import React from 'react';

/**
 * Assign / Change, on a board row and on the dispatcher's trip screen, so
 * both read and behave the same — the operator screens' TripActions, for the
 * office. The caller renders the sheet (AssignSheet with
 * `dispatcherAssignSource`) and decides what to do with what comes back.
 *
 * A closed trip takes no assignment — the API refuses one — so it offers
 * none, and says why rather than leaving a control that cannot work.
 */
export default function AssignButton({ trip, onAssign }) {
  if (trip.status !== 'Confirmed') {
    return <span className="pp-op-small pp-dispatch__closed">Closed</span>;
  }

  return (
    <button
      type="button"
      className={`pp-btn pp-btn--sm ${trip.operator ? 'pp-btn--outline' : 'pp-btn--primary'}`}
      onClick={() => onAssign(trip)}
      aria-label={`${trip.operator ? 'Change' : 'Assign'} ${trip.booking_reference}`}
    >
      {trip.operator ? 'Change' : 'Assign'}
    </button>
  );
}
